import { render, staticRenderFns } from "./PlayerPendingInfoForceApplyMigration.vue?vue&type=template&id=f96e8ba8&"
import script from "./PlayerPendingInfoForceApplyMigration.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingInfoForceApplyMigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports